import {
  ArrowsLeftRightIcon,
  BugBeetleIcon,
  BuildingsIcon,
  CameraIcon,
  ClipboardTextIcon,
  CodeIcon,
  CreditCardIcon,
  CurrencyDollarIcon,
  DatabaseIcon,
  FileTextIcon,
  FilesIcon,
  GearIcon,
  GlobeSimpleIcon,
  ImageIcon,
  ImagesIcon,
  LightningIcon,
  ListBulletsIcon,
  TrendUpIcon,
  PackageIcon,
  PauseCircleIcon,
  QrCodeIcon,
  QuestionIcon,
  ReceiptIcon,
  ShapesIcon,
  ShareNetworkIcon,
  ShoppingCartIcon,
  SparkleIcon,
  SquaresFourIcon,
  StackIcon,
  StorefrontIcon,
  TicketIcon,
  TreeViewIcon,
  TruckIcon,
  TrashIcon,
  UserGearIcon,
  UserIcon,
  UsersIcon,
  UsersThreeIcon,
  WarehouseIcon,
  BookOpenIcon,
  // HIDDEN 2026-05-27 per ask: keep import for un-hiding the REPORTS umbrella group
  // ChartBarIcon,
  ChartLineUpIcon,
  // HIDDEN 2026-05-27 per ask: keep import for un-hiding STOCK_RECONCILIATION_OVERVIEW
  // CheckSquareOffsetIcon,
  HeartbeatIcon,
  // HIDDEN 2026-05-27 per ask: keep import for un-hiding STOCK_AGEING_OVERVIEW
  // HourglassMediumIcon,
  // HIDDEN 2026-05-27 per ask: keep import for un-hiding MERCH_SCORECARD
  // GaugeIcon,
} from '@phosphor-icons/react';
import { IResource } from '../types';
import { PATHS_NAMES } from '../pathnames';

export const ADMIN_RESOURCES: Array<IResource> = [
  {
    name: 'dashboard',
    list: '/',
    meta: {
      label: 'Dashboard',
      icon: <SquaresFourIcon />,
      permissions: {
        list: ['*'],
      },
    },
  },
  {
    name: 'ccgroup',
    meta: {
      label: 'Customers',
      icon: <UserGearIcon />,
      masterRoles: ['SUPER_ADMIN', 'CC_ADMIN'],
    },
  },
  {
    name: 'customers',
    list: '/customer',
    create: '/customer/new',
    edit: '/customer/edit/:id',
    meta: {
      parent: 'ccgroup',
      label: 'Customers',
      icon: <UserIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: PATHS_NAMES.B2B_CUSTOMERS,
    list: '/b2b-customer',
    create: '/b2b-customer/new',
    show: '/b2b-customer/show/:id',
    edit: '/b2b-customer/edit/:id',
    meta: {
      parent: 'ccgroup',
      label: 'B2B Customers',
      icon: <BuildingsIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: 'storecredits',
    list: '/storecredits',
    meta: {
      parent: 'ccgroup',
      label: 'Store Credits',
      icon: <CreditCardIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: 'oms',
    meta: {
      label: 'Orders',
      icon: <DatabaseIcon />,
      masterRoles: ['SUPER_ADMIN', 'CC_ADMIN'],
    },
  },
  {
    name: 'orders',
    list: '/orders',
    show: '/orders/show/:id',
    meta: {
      parent: 'oms',
      label: 'All Orders',
      icon: <ClipboardTextIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'test-orders',
    list: '/test-orders',
    show: '/test-orders/show/:id',
    meta: {
      parent: 'oms',
      label: 'Test Orders',
      icon: <BugBeetleIcon />,
      // masterRoles: ['SUPER_ADMIN'],
      permissions: {
        list: ['SUPER_ADMIN'],
        show: ['SUPER_ADMIN'],
      },
    },
  },
  {
    name: 'ordercontrolcenter',
    list: '/ordercontrolcenter',
    meta: {
      parent: 'oms',
      label: 'Control Center',
      icon: <ShareNetworkIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.DASH_ORDERS,
    list: '/dash-orders',
    meta: {
      parent: 'oms',
      label: 'Dash Orders',
      icon: <LightningIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'on-hold-orders',
    list: '/on-hold-orders',
    meta: {
      parent: 'oms',
      label: 'On Hold Orders',
      icon: <PauseCircleIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'mtotracker',
    list: '/mtotracker',
    meta: {
      parent: 'oms',
      label: 'MTO Tracker',
      icon: <TruckIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'b2b2ctracker',
    list: '/b2b2ctracker',
    meta: {
      parent: 'oms',
      label: 'B2B2C Tracker',
      icon: <TreeViewIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'returns',
    list: '/returns',
    show: '/returns/show/:id',
    meta: {
      parent: 'oms',
      label: 'Returns',
      icon: <ArrowsLeftRightIcon />,
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.RETURN_COURIER_EXCEPTIONS,
    list: '/returns/exceptions/cancelled-awb-movement',
    meta: {
      parent: 'oms',
      label: 'Return Courier Exceptions',
      icon: <ArrowsLeftRightIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: PATHS_NAMES.REFUNDS_ON_HOLD,
    list: '/refunds-onhold',
    meta: {
      parent: 'oms',
      label: 'Refunds Onhold',
      icon: <CurrencyDollarIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: 'comments',
    list: '/comments',
    meta: {
      parent: 'oms',
      label: 'Comments',
      icon: <FilesIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: 'products',
    meta: {
      label: 'Products',
      icon: <PackageIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING', 'MARKETING', 'CC_ADMIN'],
    },
  },
  {
    name: 'better-inventory',
    list: '/products',
    meta: {
      parent: 'products',
      label: 'Products',
      icon: <PackageIcon />,
      masterRoles: ['BRAND_MANAGER', 'MARKETING', 'CC_ADMIN'],
    },
  },
  {
    name: 'style-metadata-corrections',
    list: '/products/style-metadata',
    meta: {
      parent: 'products',
      label: 'AI Style Metadata',
      icon: <SparkleIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING', 'MARKETING', 'CC_ADMIN'],
    },
  },
  {
    name: 'categories',
    list: '/categories',
    create: '/categories/new',
    edit: '/categories/edit/:id',
    meta: {
      parent: 'products',
      label: 'Categories',
      icon: <ShapesIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING'],
    },
  },
  {
    name: 'skualbums',
    list: '/skualbums',

    meta: {
      parent: 'products',
      label: 'Albums',

      icon: <SquaresFourIcon />,
      masterRoles: ['CATALOGING', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'aialbums',
    list: '/aialbums',
    meta: {
      parent: 'products',
      label: 'AI Albums',
      icon: <ImagesIcon />,
      masterRoles: ['CATALOGING', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'inventory',
    list: '/inventory',
    meta: {
      parent: 'products',
      label: 'Inventory',
      icon: <PackageIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING', 'MARKETING', 'CC_ADMIN'],
    },
  },
  {
    name: 'sku-delete',
    list: '/skus/delete',
    meta: {
      parent: 'products',
      label: 'Delete SKUs',
      icon: <TrashIcon />,
      masterRoles: ['SUPER_ADMIN', 'CATALOGING'],
    },
  },

  {
    name: 'questionnaire',
    list: '/questionnaire',
    meta: {
      parent: 'products',
      label: 'QnA',
      icon: <QuestionIcon />,
      masterRoles: ['CC_ADMIN'],
    },
  },
  {
    name: 'collections',
    list: '/collections',
    create: '/collections/new',
    edit: '/collections/edit/:id',
    meta: {
      parent: 'products',
      label: 'Collections',
      icon: <SquaresFourIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING'],
    },
  },
  {
    name: 'sort-strategies',
    list: '/sort-strategies',
    create: '/sort-strategies/new',
    edit: '/sort-strategies/edit/:id',
    show: '/sort-strategies/show/:id',
    meta: {
      parent: 'products',
      label: 'Sort Strategies',
      icon: <ListBulletsIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING'],
    },
  },
  {
    name: 'settings',
    meta: {
      label: 'Admin',
      icon: <GearIcon />,
      masterRoles: ['SUPER_ADMIN', 'WAREHOUSE_MANAGER', 'BRAND_MANAGER'],
    },
  },
  // {
  //   name: 'attributes',
  //   list: '/attributes',
  //   meta: {
  //     parent: 'products',
  //     label: 'Attributes',
  //     icon: <DatabaseIcon />,
  //     masterRoles: ['CATALOGING'],
  //   },
  // },
  {
    name: 'facilities',
    list: '/facilities',
    create: '/facilities/new',
    show: '/facilities/show/:id',
    edit: '/facilities/edit/:id',
    meta: {
      parent: 'settings',
      label: 'Facilities',
      icon: <StorefrontIcon />,
      masterRoles: ['SUPER_ADMIN', 'RETAIL_OPS'],
      permissions: {
        list: ['WAREHOUSE_MANAGER'],
        show: ['WAREHOUSE_MANAGER', 'BRAND_MANAGER'],
        create: ['WAREHOUSE_MANAGER'],
        edit: ['BRAND_MANAGER'],
      },
    },
  },
  {
    name: 'saleschannels',
    list: '/saleschannels',
    edit: '/saleschannels/edit/:id',
    meta: {
      parent: 'settings',
      label: 'Sales Channels',
      icon: <GlobeSimpleIcon />,
      masterRoles: ['SUPER_ADMIN'],
    },
  },
  // {
  //   name: 'usergroup',
  //   meta: {
  //     parent: 'settings',
  //     label: 'Users',
  //     icon: <UsersThreeIcon />,
  //     masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
  //   },
  // },
  {
    name: 'erpusers',
    list: '/users/erp',
    create: '/users/erp/new',
    edit: 'users/erp/edit/:id',
    meta: {
      parent: 'settings',
      label: 'ERP Users',
      icon: <UsersThreeIcon />,
      masterRoles: ['SUPER_ADMIN'],
    },
  },
  {
    name: 'vendorusers',
    list: '/users/vendor',
    create: '/users/vendor/new',
    edit: '/users/vendor/edit/:id',
    meta: {
      parent: 'settings',
      label: 'Vendor Users',
      icon: <BuildingsIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'storeusers',
    list: '/users/store',
    create: '/users/store/new',
    edit: '/users/store/edit/:id',
    meta: {
      parent: 'settings',
      label: 'Store Staff',
      icon: <UsersIcon />,
      masterRoles: ['SUPER_ADMIN'],
    },
  },
  {
    name: 'utility',
    meta: {
      label: 'Utility',
      icon: <CodeIcon />,
      masterRoles: ['*'],
    },
  },
  {
    name: PATHS_NAMES.CRM,
    meta: {
      label: 'CRM',
      icon: <TrendUpIcon />,
      masterRoles: ['SUPER_ADMIN', 'CRM_MANAGER'],
    },
  },
  {
    name: 'assets',
    list: '/utility/assets',
    meta: {
      parent: 'utility',
      label: 'Upload Asset',
      icon: <ImageIcon />,
      masterRoles: ['BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.DEEPLINKS,
    list: '/utility/deeplinks',
    meta: {
      parent: 'utility',
      label: 'Deeplinks',
      icon: <ShareNetworkIcon />,
      masterRoles: ['MARKETING'],
    },
  },
  {
    name: PATHS_NAMES.NOTIFICATIONS,
    list: '/utility/notifications',
    meta: {
      parent: PATHS_NAMES.CRM,
      label: 'Notifications',
      icon: <LightningIcon />,
      masterRoles: ['SUPER_ADMIN', 'CRM_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.CRM_MANAGEMENT,
    list: '/utility/crm',
    meta: {
      parent: PATHS_NAMES.CRM,
      label: 'Campaigns',
      icon: <TrendUpIcon />,
      masterRoles: ['SUPER_ADMIN', 'CRM_MANAGER'],
    },
  },
  {
    name: 'lookbook',
    list: '/utility/lookbook',
    meta: {
      parent: 'utility',
      label: 'Lookbook',
      icon: <ImagesIcon />,
      masterRoles: ['SUPER_ADMIN', 'CATALOGING'],
    },
  },
  {
    name: 'store-images',
    list: '/utility/store-images',
    meta: {
      parent: 'utility',
      label: 'Store Images',
      icon: <CameraIcon />,
      masterRoles: ['BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.AUDIT_HISTORY,
    list: '/utility/audit-history',
    meta: {
      parent: 'utility',
      label: 'Audit History',
      icon: <ClipboardTextIcon />,
      masterRoles: ['SUPER_ADMIN'],
    },
  },
  {
    name: 'shopify',
    meta: {
      label: 'Shopify', // Shopify Admin
      icon: <StorefrontIcon />,
      masterRoles: ['ONLINE_MERCH'],
    },
  },

  {
    name: 'metafields',
    list: '/shopify/metafields',
    meta: {
      parent: 'shopify',
      label: 'Meta-fields',
      icon: <ListBulletsIcon />,
      masterRoles: ['ONLINE_MERCH'],
    },
  },

  {
    name: 'pages',
    list: '/shopify/pages',
    meta: {
      parent: 'shopify',
      label: 'Pages',
      icon: <FileTextIcon />,
      masterRoles: ['ONLINE_MERCH'],
    },
  },

  {
    name: PATHS_NAMES.PAGE_BUILDER,
    meta: {
      label: 'Page Builder',
      icon: <TreeViewIcon />,
      masterRoles: ['CATALOGING'],
    },
  },

  {
    name: PATHS_NAMES.PAGE_BUILDER_PAGES,
    list: '/page-builder/pages',
    meta: {
      parent: 'page-builder',
      label: 'Pages',
      icon: <FileTextIcon />,
      masterRoles: ['CATALOGING'],
    },
  },

  // {
  //   name: 'collections',
  //   list: '/shopify/collections',
  //   meta: {
  //     parent: 'shopify',
  //     label: 'Collections',
  //     icon: <CollectionsIcon size={14} />,
  //     masterRoles: [],
  //   },
  // },

  // {
  //   name: 'products',
  //   list: '/shopify/products',
  //   meta: {
  //     parent: 'shopify',
  //     label: 'Products',
  //     icon: <BarcodeIcon size={14} />,
  //     masterRoles: [],
  //   },
  // },

  {
    name: 'vendormanagement',
    meta: {
      label: 'Vendor ', // Vendor Management
      icon: <TruckIcon />,
      masterRoles: ['BRAND_MANAGER'],
    },
  },
  {
    name: 'vendors',
    meta: {
      parent: 'vendormanagement',
      label: 'Vendors',
      icon: <UsersThreeIcon />,
      masterRoles: ['BRAND_MANAGER'],
      permissions: {
        list: ['CATALOGING'],
        show: ['CATALOGING'],
      },
    },
    list: '/vendors',
    show: '/vendors/show/:id',
    create: '/vendors/new',
    edit: '/vendors/edit/:id',
  },

  {
    name: 'couponmanagement',
    meta: {
      label: 'Coupons',
      icon: <TicketIcon />,
      masterRoles: ['COUPON_MANAGER'],
    },
  },
  {
    name: 'coupons',
    meta: {
      parent: 'couponmanagement',
      label: 'Coupons',
      icon: <TicketIcon />,
      masterRoles: ['COUPON_MANAGER'],
      permissions: {
        list: ['COUPON_MANAGER'],
        show: ['COUPON_MANAGER'],
      },
    },
    list: '/coupons',
    show: '/coupons/show/:id',
    create: '/coupons/new',
    edit: '/coupons/edit/:id',
  },
  {
    name: 'promotions',
    list: '/promotions',
    show: '/promotions/show/:id',
    create: '/promotions/new',
    edit: '/promotions/edit/:id',
    meta: {
      label: 'Promotions',
      icon: <CurrencyDollarIcon />,
      masterRoles: ['DISCOUNT_MANAGER'],
      permissions: {
        list: ['DISCOUNT_MANAGER', 'BRAND_MANAGER'],
        show: ['DISCOUNT_MANAGER', 'BRAND_MANAGER'],
        create: ['SUPER_ADMIN'],
        edit: ['SUPER_ADMIN', 'BRAND_MANAGER'],
      },
    },
  },
  {
    name: 'skus',
    list: '/skus',
    meta: {
      parent: 'vendormanagement',
      label: 'Vendor Catalog',
      icon: <QrCodeIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING'],
      permissions: {
        list: ['BRAND_MANAGER', 'CATALOGING', 'WAREHOUSE_ADMIN'],
        edit: ['BRAND_MANAGER', 'CATALOGING', 'VENDOR_ADMIN'],
        print_labels: ['WAREHOUSE_ADMIN'],
      },
    },
  },
  {
    name: 'vendorfacilities',
    list: '/vendorfacilities',
    meta: {
      parent: 'vendormanagement',
      label: 'Facilities',
      icon: <WarehouseIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING'],
    },
  },
  {
    name: 'vendorinventory',
    list: '/vendorinventory',
    meta: {
      parent: 'vendormanagement',
      label: 'JIT Inventory',
      icon: <StackIcon />,
      masterRoles: ['BRAND_MANAGER', 'CATALOGING'],
    },
  },
  {
    name: 'buying',
    meta: {
      label: 'Buying',
      icon: <WarehouseIcon />,
      masterRoles: ['BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.STOCK_TRANSFER,
    list: '/stocktransfer',
    create: '/stocktransfer/new',
    edit: '/stocktransfer/edit/:id',
    meta: {
      parent: 'buying',
      label: 'Stock Transfer Requests',
      icon: <TruckIcon />,
      masterRoles: ['BRAND_MANAGER', 'WAREHOUSE_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.MANIFESTS,
    create: '/manifests/create',
    show: '/manifests/:id/show',
    meta: {
      masterRoles: ['BRAND_MANAGER', 'WAREHOUSE_MANAGER'],
    },
  },
  {
    name: 'deliverychallans',
    list: '/deliverychallans',
    create: '/deliverychallans/new',
    show: '/deliverychallans/show/:id',
    edit: '/deliverychallans/edit/:id',
    meta: {
      parent: 'buying',
      label: 'Delivery Challans',
      icon: <ReceiptIcon />,
      masterRoles: ['BRAND_MANAGER'],
      permissions: {
        list: ['CATALOGING', 'CATALOGING_SUPERVISOR'],
        show: ['CATALOGING', 'CATALOGING_SUPERVISOR'],
        edit: ['CATALOGING', 'CATALOGING_SUPERVISOR'],
      },
    },
  },
  {
    name: 'purchaseorders',
    list: '/purchaseorders',
    create: '/purchaseorders/new',
    show: '/purchaseorders/show/:id',
    edit: '/purchaseorders/edit/:id',
    meta: {
      parent: 'buying',
      label: 'Purchase Orders',
      icon: <ShoppingCartIcon />,
      masterRoles: ['BRAND_MANAGER'],
      permissions: {
        list: ['CATALOGING'],
      },
    },
  },
  {
    name: 'packages',
    show: '/packages/show/:id',
    meta: {
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'lineitems',
    show: '/lineitems/show/:id',
    meta: {
      masterRoles: ['CC_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: 'refunds',
    show: '/refunds/show/:id',
    meta: {
      masterRoles: ['CC_ADMIN'],
    },
  },
  { name: 'skuupload' },
  { name: 'pincode' },
  /* HIDDEN 2026-05-27 per ask: legacy umbrella retained for restore. The
     Sider's PanelContent only renders one level of nesting, so Merch and
     Ops Reports are now siblings at the top of the rail rather than nested
     children of this group. Restoring this entry without flattening the
     children below will produce a panel of un-clickable group links.
  {
    name: PATHS_NAMES.REPORTS,
    meta: {
      label: 'Reports',
      icon: <ChartBarIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  */
  {
    name: PATHS_NAMES.MERCH_REPORTS,
    meta: {
      label: 'Merch Reports',
      icon: <ChartLineUpIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.OPS_REPORTS,
    meta: {
      label: 'Ops Reports',
      icon: <PackageIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  /* HIDDEN 2026-05-27 per ask: keep route intact, hide from sidebar
  {
    name: PATHS_NAMES.MERCH_SCORECARD,
    list: '/merch-scorecard',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'Merch Scorecard',
      icon: <GaugeIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  */
  {
    name: PATHS_NAMES.STORE_BRAND_OVERVIEW,
    list: '/store-brand-overview',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'Store × Brand',
      icon: <BuildingsIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.BESTSELLERS_TRENDS_OVERVIEW,
    list: '/bestsellers-trends-overview',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'Bestsellers & Trends',
      icon: <ChartLineUpIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.ONLINE_PERFORMANCE_OVERVIEW,
    list: '/online-performance-overview',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'Online Performance',
      icon: <GlobeSimpleIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.MTO_HEALTH_OVERVIEW,
    list: '/mto-health-overview',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'MTO / MTC / JIT Health',
      icon: <HeartbeatIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.JIT_B2B2C_OVERVIEW,
    list: '/jit-b2b2c-overview',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'JIT B2B2C',
      icon: <HeartbeatIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.CATALOGING_HEALTH_OVERVIEW,
    list: '/cataloging-health-overview',
    meta: {
      parent: PATHS_NAMES.MERCH_REPORTS,
      label: 'Cataloging Health',
      icon: <BookOpenIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  /* HIDDEN 2026-05-27 per ask: keep route intact, hide from sidebar
  {
    name: PATHS_NAMES.STOCK_AGEING_OVERVIEW,
    list: '/stock-ageing-overview',
    meta: {
      parent: PATHS_NAMES.OPS_REPORTS,
      label: 'Stock Overview & Ageing',
      icon: <HourglassMediumIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  */
  {
    name: PATHS_NAMES.WEEKLY_MERCH_OVERVIEW,
    list: '/weekly-merch-overview',
    meta: {
      parent: PATHS_NAMES.OPS_REPORTS,
      label: 'Inwards Overview',
      icon: <PackageIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  {
    name: PATHS_NAMES.STOCK_TRANSFER_OVERVIEW,
    list: '/stock-transfer-overview',
    meta: {
      parent: PATHS_NAMES.OPS_REPORTS,
      label: 'Stock Transfer',
      icon: <TruckIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  /* HIDDEN 2026-05-27 per ask: keep route intact, hide from sidebar
  {
    name: PATHS_NAMES.STOCK_RECONCILIATION_OVERVIEW,
    list: '/stock-reconciliation-overview',
    meta: {
      parent: PATHS_NAMES.OPS_REPORTS,
      label: 'Stock Reconciliation',
      icon: <CheckSquareOffsetIcon />,
      masterRoles: ['SUPER_ADMIN', 'BRAND_MANAGER'],
    },
  },
  */
];
